import {React, useLocalStore, observer, action, useEffect} from '@api'
import {Tooltip2} from '@api'
import {useVipLocalStore, VipLocalStore} from '@modules'

import {CatalogItemSidebarDetailsStore, useCatalogItemSidebarDetailsStore} from '@modules'
import {StoresInstance} from '@stores'
import {PrimaryIconButton} from 'centric-ui-components'
import {computed, observable} from 'mobx'
import * as css from './ModalNotes.css'
import {Icon} from '@blueprintjs/core'
import { Tooltip } from '@material-ui/core'

class ModalDetailNotesStore extends VipLocalStore {
  constructor(stores: StoresInstance,public detailsStore: CatalogItemSidebarDetailsStore) {
    super(stores)
  }

  @computed get config() {
    return this.detailsStore.modal.config.notes
  }

  @computed get notes() {
    const {es, config, detailsStore: {data}} = this
    return _.get(data, config.field) ?? ''
  }

  @action onChangeNotes = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const {detailsStore: {updateFieldData, data}, config} = this
    updateFieldData(config.field, e.target.value)
  }

  // @observable isEditing = true
  // @action toggleEdit = () => this.isEditing = !this.isEditing
  // @action startEditing = () => this.isEditing = true
  // @action stopEditing = () => this.isEditing = false

  @observable.ref inputRef: HTMLTextAreaElement
  @action setInputRef = r => this.inputRef = r
}

export const ModalDetailNotes = observer<React.HTMLProps<HTMLDivElement>>(({className, ...props}) => {
  const detailsStore = useCatalogItemSidebarDetailsStore(),
    {strings, config, notes, onChangeNotes, inputRef, setInputRef} = useVipLocalStore((ws) => new ModalDetailNotesStore(ws, detailsStore))

  // useEffect(() => {
  //   if (inputRef && isEditing) {
  //     inputRef.focus()
  //   }
  // }, [inputRef, isEditing])

  // console.log({isEditing, notes})
  return (
    config &&
	<div className={css.notes}
	     // data-is-editing={isEditing}
	     data-grid-area='notes'
       data-empty={notes == '' || notes == null}
	     data-field={config.field}>
		{/*<div className={css.header}>*/}
		{/*	<label>Notes</label>*/}
		{/*	<Tooltip2 content={`${strings.edit} ${strings.notes}`}>*/}
    {/*      <PrimaryIconButton icon={<Icon icon='edit'/>} active={isEditing} onClick={toggleEdit}/>*/}
    {/*  </Tooltip2>*/}
		{/*</div>*/}
		<textarea ref={setInputRef} placeholder={strings.addNotes} value={notes} onChange={onChangeNotes}/>
		{/*<div className={css.textHTML}>
          {notes ? <div className={css.html} dangerouslySetInnerHTML={{__html: notes}}/>
                 : <span className={css.placeholderText}>Type a message...</span>
          }
		</div>*/}
	</div>)
})


// WEBPACK FOOTER //
// ./src/modules/CatalogItemDetails/CatalogItemSidebarDetails/Modal/ModalNotes.tsx